export const loadNewPipelineVersionPage = (pipelineHistoryResponse, workspaceId, history) => {
  const pipelineID = pipelineHistoryResponse?.data?.pipeline_version[0]?.pipeline?.pipeline_id;
  const newVersion = pipelineHistoryResponse?.data?.pipeline_version[0].version;

  // Routes to the Details Tab by default
  history.push(`/workspaces/${workspaceId}/pipelines/${pipelineID}/versions/${newVersion}/details`);
}
